import { Component, Input } from '@angular/core';
import { ProposalShortlistItem } from '../../models/mercer-support-incumbent-member.model';

@Component({
  selector: 'coin-c-positions-overlay',
  templateUrl: './positions-overlay.component.html',
  styleUrls: ['./positions-overlay.component.scss'],
  standalone: false
})
export class PositionsOverlayComponent {
  @Input() finalIncumbentPositions: ProposalShortlistItem[] | undefined;
  @Input() shortlistedOnOpenPositions: ProposalShortlistItem[] | undefined;
  @Input() shortlistedOnClosedPositions: ProposalShortlistItem[] | undefined;
}
